/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_RegisteredInputs */

const de__field_registered = /** @type {(inputs: _Field_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angemeldet zum CHANCENabschluss`)
};

/**

* @param {_Field_RegisteredInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_registered = /** @type {((inputs?: _Field_RegisteredInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_RegisteredInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_registered(inputs)
});